import { createSelector } from "reselect";
import { createAction } from "redux-actions";
import { path, identity } from "ramda";

export const SET_DLS_LOADING = "APP@MATERIAL::DLS_MATERIALS::LOADING";
export const setDLSLoading = createAction(SET_DLS_LOADING);

export const selectIsDLSLoading = createSelector(
  path(["application", "materials", "isDLSMaterialsLoading"]),
  identity
);

const initialState = () => true;

export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    case SET_DLS_LOADING:
      return action.payload;
    default:
      return state;
  }
}
